import styled from 'styled-components';

export const Toolbar = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: space-between;
  margin: 0 1rem 1rem;

  @media (max-width: 520px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const ImageCount = styled.p`
  color: ${(props) => props.theme.colors.textLight};
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0;
`;

export const LimitHint = styled.p`
  color: ${(props) => props.theme.colors.warning};
  font-size: 0.8rem;
  margin: 0.35rem 0 0;
`;

export const FileName = styled.span`
  display: block;
  max-width: 22rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const EmptyState = styled.p`
  color: ${(props) => props.theme.colors.textLight};
  margin: 2rem 1rem;
  text-align: center;
`;

export const DeleteConfirmation = styled.div`
  padding: 1rem;

  p {
    margin: 0 0 0.75rem;
  }

  strong {
    overflow-wrap: anywhere;
  }
`;

export const RowActions = styled.div`
  align-items: center;
  display: flex;
  gap: 0.25rem;
  justify-content: center;
`;

export const RowActionButton = styled.button<{ $danger?: boolean }>`
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 0.4rem;
  color: ${(props) => (props.$danger ? props.theme.colors.negative : props.theme.colors.onSurface)};
  cursor: pointer;
  display: inline-flex;
  height: 2rem;
  justify-content: center;
  padding: 0.4rem;
  transition: background 0.15s ease, color 0.15s ease;
  width: 2rem;

  &:hover:not(:disabled) {
    background: ${(props) => `${props.$danger ? props.theme.colors.negative : props.theme.colors.primary}18`};
    color: ${(props) => (props.$danger ? props.theme.colors.negative : props.theme.colors.primary)};
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.primary};
    outline-offset: 2px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
